import React, { Fragment } from 'react';
import { string, func } from 'prop-types';
import { Query } from 'react-apollo';
import ErrorBoundary from 'components/ErrorBoundary';
import { GET_SAVED_STORY } from 'graphql/getSavedStory';

/**
 *
 * Get saved stories query used for checking if a story has been saved
 */
function GetSavedStory(props) {
  const { communityId, auth0User, resourceId, site, children } = props;

  // Save errors on the client and catch on the server
  const errorPolicy = process.browser ? 'all' : 'none';

  return (
    <ErrorBoundary>
      <Query
        query={GET_SAVED_STORY}
        variables={{ communityId, auth0User, resourceId, site }}
        errorPolicy={errorPolicy}
        ssr={false}
      >
        {({ data: queryData, loading: queryLoading, error: queryError }) => {
          return (
            <Fragment>
              {children({
                data: queryData,
                error: queryError,
                loading: queryLoading
              })}
            </Fragment>
          );
        }}
      </Query>
    </ErrorBoundary>
  );
}

GetSavedStory.propTypes = {
  communityId: string,
  auth0User: string,
  resourceId: string.isRequired,
  site: string.isRequired,
  children: func.isRequired
};

GetSavedStory.defaultProps = {
  communityId: undefined,
  auth0User: undefined
};

export default GetSavedStory;
